import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class TailorService extends GenericService {
  constructor() {
    super('/tailors', axiosInstance);
  }
}

export default new TailorService(); 